import BaseSubmitField from 'registration/js/base/fields/submit';

import template from 'registration/templates/dark/fields/submit.html';

const SubmitField = BaseSubmitField.extend({ template });

export default SubmitField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/submit.js